<article
  class="role-tile role-tile--target break m-l_flex l_flex l_flex-column l_flex-justify"
  [attr.aria-label]="item.name"
  [ngClass]="{ 'corner-check--tile': item.selected }"
>
  <df-icon
    *ngIf="item.selected"
    size="medium"
    class="role-tile--selected"
    icon="checkmark"
  ></df-icon>
  <div class="center-text guts-m-full-1 l_flex-grow-vertical">
    <header class="guts-m-b-1">
      <h3 class="h3 role-tile__title">
        {{ item.name | ellipsis: 45 }}
      </h3>
    </header>
    <p class="par par--small" *ngIf="description">
      {{ description | ellipsis: 140 }}
    </p>
  </div>
</article>
